import { graphql } from '@/gql';
import type { GetStoresQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { GourmetStoresList } from '@/models/gourmet';

export const getStores = async ({
  address,
  query,
  group,
  services,
  isSpecialOffersEnabled,
}: GetStoresQueryVariables): Promise<GourmetStoresList> => {
  const response = await queryExecute({
    query: graphql(`
      query getStores(
        $address: DeliveryAddressInputType!
        $query: String!
        $group: Boolean!
        $services: [String!]
        $isSpecialOffersEnabled: Boolean
      ) {
        getStores(address: $address, query: $query, group: $group, services: $services, isSpecialOffersEnabled: $isSpecialOffersEnabled) {
          stores {
            id
            title
            subtitle
            score
            imageUrl
            isAvailable
            stores {
              id
              serviceId
              service
              promotion {
                text
                description
                promotionUuid
              }
              url
              title
              subtitle
              serviceFee
              timeEstimate {
                min
                max
              }
              printMenu
              isAvailable
              averageRating
              ratings
              priceRange
              distance
            }
          }
          meta {
            avgScore
            maxScore
          }
          status {
            failures
          }
        }
      }
    `),
    variables: {
      address,
      query,
      group,
      services,
      isSpecialOffersEnabled,
    },
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  });

  return response.data.getStores;
};
